import { render, staticRenderFns } from "./setPayPassword.vue?vue&type=template&id=13fd6840&scoped=true"
import script from "./setPayPassword.vue?vue&type=script&lang=js"
export * from "./setPayPassword.vue?vue&type=script&lang=js"
import style0 from "./setPayPassword.vue?vue&type=style&index=0&id=13fd6840&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd6840",
  null
  
)

export default component.exports